<template>
  <div class="wrapper">
    <div class="container">
      <p class="title">Export Users</p>
      <div class="inner-container">
        <p>From</p>
        <date-picker
          v-model="startDate"
          placeholder="Start date"
          format="DD/MM/YYYY"
          value-type="DD/MM/YYYY"
        />
      </div>
      <div class="inner-container">
        <p>To</p>
        <date-picker
          v-model="endDate"
          placeholder="End date"
          format="DD/MM/YYYY"
          value-type="DD/MM/YYYY"
        />
      </div>
        <div class="inner-container">
          <button
            class="submit-btn"
            :class="{'disable': (!file || !startDate || !endDate || buttonDisable)}"
            @click="getExportDocument"
          >
          Export
          </button>          
        </div>
    </div>
    <button class="close-modal" @click="$emit('close')" />
  </div>
</template>
<script>
import SolFileAPIInstance from '@/api'
export default {
  name: "ExportDialog",
  data() {
    return {
      startDate: '',
      endDate: '',
      file: [],
      loading: false ,
      buttonDisable: false
    }
  },
  methods: {
    async getExportDocument() {
      this.buttonDisable = true
      if(this.startDate && this.endDate){
        const response = await SolFileAPIInstance.handleExportUsers({from: this.startDate, to:this.endDate})
        
        if(response.status === 200) {
          this.handleSuccessMessage
        }
        this.$emit('close')
        return
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper{
  position: relative;
  .container {
    display: grid;
    gap: 30px;
    .title{
      font-size: 24px;
      font-weight: 600;
      text-align: center;
      margin: 10px 0;
    }
    .inner-container{
      display: grid;
      grid-template-columns: 40px 4fr 40px;
      gap: 20px;
      @media screen and (max-width: 767px) {
        grid-template-columns: 1fr 4fr;
      }
      p{
        display: flex;
        align-items: center;
        width: 40px;
        margin: 0;
      }
    }
    .submit-btn{
      margin: 0 auto;
      font-size: 18px;
      font-weight: bold;
      border: 2px solid #000;
      border-radius: 50px;
      padding: 5px 20px;
      max-width: 210px;
      width: 100%;
      grid-column-start: 2;
      text-align: center;
      @media screen and (max-width: 767px) {
        grid-column-start: 1;
        grid-column-end: 3;
        max-width: none;
      }
      &.disable{
        pointer-events: none;
        color: rgb(129, 129, 129);
        border-color: rgb(129, 129, 129);
        &:hover{
          color: #fff;
        }
      }
    }
  }

  .close-modal{
    position: absolute;
    top: -10px;
    right: -20px;
    width: 20px;
    height: 20px;
    padding: 0;
    @media screen and (max-width: 767px) {
      right: 0;
    }
    &:before{
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      width: 100%;
      height: 1px;
      transform: translate(-50%, -50%) rotate(45deg);
      background: #000;
    }

    &:after{
      content: '';
      position: absolute;
      left: 50%;
      top: 50%;
      width: 100%;
      height: 1px;
      transform: translate(-50%, -50%) rotate(-45deg);
      background: #000;
    }
  }
}

</style>